/**
© NkApps. You are permitted to use this content within your store. Redistribution or use in any other application is strictly prohibited. 
Unauthorized copying, distribution, or reproduction in any form will result in legal action.
**/
if (!customElements.get("nk-accordion")) {
  customElements.define(
    "nk-accordion",
    class NkAccordion extends HTMLElement {
      constructor() {
        super();

        this.querySelectorAll(".nk-accordion-btn").forEach((button) => {
          button.addEventListener("click", () => {
            const answer = button.nextElementSibling;
            button.classList.toggle("active");
            answer.classList.toggle("active");
          });
        });
      }
    }
  );
}
